
import Tassel from "./Tassel";

export default function Tassels(props) {

    return(

        <group>

            <Tassel
                {...props}
                groupRotation = { [0.0,0.0,0.0] }
                delay = {500}
                index = {2}
            ></Tassel>
            

            <Tassel
                {...props}
                groupRotation = { [0.0,0.5235,0.0] }
                delay = {1000}
                index = {2}
            ></Tassel>

            <Tassel
                {...props}
                groupRotation = { [0.0,1.047,0.0] }
                delay = {1500}
                index = {2}
            ></Tassel>

            <Tassel
                {...props}
                groupRotation = { [0.0,1.5705,0.0] }
                delay = {2000}
                index = {2}
            ></Tassel>

            <Tassel
                {...props}
                groupRotation = { [0.0,2.094,0.0] }
                index = {3}
            ></Tassel>

            <Tassel
                {...props}
                groupRotation = { [0.0,2.6175,0.0] }
                index = {3}
            ></Tassel>

            <Tassel
                {...props}
                groupRotation = { [0.0,3.141,0.0] }
                index = {4}
            ></Tassel>

            <Tassel
                {...props}
                groupRotation = { [0.0,-2.6175,0.0] }
                index = {4}
            ></Tassel>

            <Tassel
                {...props}
                groupRotation = { [0.0,-2.094,0.0] }
                index = {4}
            ></Tassel>

            <Tassel
                {...props}
                groupRotation = { [0.0,-1.5705,0.0] }
                index = {5}
            ></Tassel>

            <Tassel
                {...props}
                groupRotation = { [0.0,-1.047,0.0] }
                index = {5}

            ></Tassel>

            <Tassel
                {...props}
                groupRotation = { [0.0,-0.5235,0.0] }
                index = {5}
            ></Tassel>



        </group>

    )
}